import { render, staticRenderFns } from "./NpmAuditAnalyzer.vue?vue&type=template&id=17967915&"
import script from "./NpmAuditAnalyzer.vue?vue&type=script&lang=js&"
export * from "./NpmAuditAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports